const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'Acceso API',
    apiAppContent:
      'Con la API de Enlighten Systems, los desarrolladores de software pueden escribir aplicaciones externas que lean datos de producción del sistema. Estas aplicaciones pueden solicitarte que introduzcas una ID de usuario para poder realizar solicitudes API en tu nombre. Tu ID de usuario es %{user_id}.',
    showApp: 'Mostrar aplicaciones que cuenten con acceso API',
    isGrantedApp: 'No has otorgado acceso API a ninguna aplicación.',
    apiSystemContent:
      'Una aplicación externa solo puede recuperar datos de sistemas que permitan acceso API. El propietario del sistema es el encargado de controlar esta opción. Si un sistema que puedes ver no se muestra aquí, se debe a que el propietario ha decidido no permitir el acceso API.',
    showSystem: 'Mostrar sistemas que permitan el acceso API',
    isGrantedSystem: 'No has otorgado acceso API a ningún sistema.',
    revokeAccess: 'Revocar acceso'
  }
};

export default apiAccess;
